var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-content',[(_vm.status === 'successShop' && _vm.active_psp === 'loaded')?_c('gateway-form',{attrs:{"submit":_vm.update,"form_data":_vm.form_data,"psp":_vm.psp,"port_config":_vm.port_config}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }